const sizeChart = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const url = new URL(window.location.href);
    const baseUrl = `${url.protocol}//${url.host}`;
    let currentVariant = "";

    const productSize = document.querySelector("#product_size_variation");
    if (productSize) {
      redirectUrl(productSize, baseUrl, currentVariant);
    }

    const adopterSize = document.querySelector("#applewatch_adopter_variation");
    if (adopterSize) {
      redirectUrl(adopterSize, baseUrl, currentVariant);
    }
  });
};

const redirectUrl = (sizeElement, baseurl, currentVariant) => {
  if (!sizeElement) return;

  let variant_id = "";
  let productUrl = "";
  const oldSelected = sizeElement.selectedIndex;

  sizeElement.addEventListener("change", async () => {
    const variantElement = document.querySelector(
      ".variant-option__swatch-value",
    );
    if (variantElement) {
      currentVariant = variantElement.textContent;
    }

    const selectedIndex = sizeElement.selectedIndex;

    sizeElement.options[oldSelected].defaultSelected = false;
    sizeElement.options[selectedIndex].setAttribute("selected", "selected");

    const selectedOption = sizeElement.querySelector("option[selected]");
    const url = `${baseurl}${selectedOption.value}.js`;

    const productObject = await getProductJsonSize(url);

    const nextProduct = productObject.variants;
    nextProduct.forEach((element) => {
      if (element.title === currentVariant) {
        variant_id = element.id;
        productUrl = `${baseurl}${selectedOption.value}?variant=${variant_id}`;
      }
    });

    if (productUrl === "") {
      productUrl = `${baseurl}${selectedOption.value}`;
    }

    window.location.replace(productUrl);
  });
};

const getProductJsonSize = async (url) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return await response.json();
  } catch (error) {
    console.error(error);
    throw new Error("Failed to get product JSON.");
  }
};

sizeChart();
